import React, { useEffect, useState } from 'react';
import { Box, TextField, Button, Typography, Grid } from '@mui/material';
import { API_BASE_URL } from '../services/fetchData';
import { useAlerta } from '../contexts/AlertaContext';

export default function Prensa() {
    const showAlerta = useAlerta();

    const [formulario, setFormulario] = useState({
        nombre: '',
        apellido: '',
        dni: '',
        email: '',
        telefono: '',
        tipoMedio: '',
        nombreMedio: '',
        localidad: '',
        instagram: '',
        facebook: '',
        twitter: '',
        foto: null,
        cartaMembretada: null,
        comentarios: ''
    });

    useEffect(() => {
        document.title = "Acreditaciones de Prensa - Festival 2026";
    }, []);

    const handleChange = (field) => (event) => {
        setFormulario({ ...formulario, [field]: event.target.value });
    };

    const handleFileChange = (field) => (event) => {
        setFormulario({ ...formulario, [field]: event.target.files[0] });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const camposRequeridos = [
            { nombre: 'El nombre es', valor: formulario.nombre },
            { nombre: 'El apellido es', valor: formulario.apellido },
            { nombre: 'El DNI es', valor: formulario.dni },
            { nombre: 'El email es', valor: formulario.email },
            { nombre: 'El teléfono es', valor: formulario.telefono },
            { nombre: 'El tipo de medio es', valor: formulario.tipoMedio },
            { nombre: 'El nombre del medio es', valor: formulario.nombreMedio },
            { nombre: 'La localidad es', valor: formulario.localidad },
            { nombre: 'La foto es', valor: formulario.foto },
            { nombre: 'La carta membretada es', valor: formulario.cartaMembretada },
        ];

        for (let campo of camposRequeridos) {
            if (!campo.valor) {
                showAlerta('error', `${campo.nombre} requerido`);
                return;
            }
        }


        let formData = new FormData();
        formData.append('nombre', formulario.nombre);
        formData.append('apellido', formulario.apellido);
        formData.append('correo_electronico', formulario.email);
        formData.append('telefono', formulario.telefono);
        formData.append('dni', formulario.dni);
        formData.append('tipo_medio', formulario.tipoMedio);
        formData.append('nombre_medio', formulario.nombreMedio);
        formData.append('localidad', formulario.localidad);
        formData.append('instagram', formulario.instagram);
        formData.append('facebook', formulario.facebook);
        formData.append('x_twitter', formulario.twitter);
        formData.append('foto', formulario.foto);
        formData.append('carta_membretada', formulario.cartaMembretada);
        formData.append('comentarios', formulario.comentarios);

        fetch(`${API_BASE_URL}prensa/`, {
            method: 'POST',
            body: formData
        })
            .then(response => {
                if (response.status === 413) {
                    throw new Error('413');
                }
                return response.json();
            })
            .then(data => {
                showAlerta('success', 'Formulario enviado correctamente');
                setFormulario({
                    nombre: '',
                    apellido: '',
                    dni: '',
                    email: '',
                    telefono: '',
                    tipoMedio: '',
                    nombreMedio: '',
                    localidad: '',
                    instagram: '',
                    facebook: '',
                    twitter: '',
                    foto: null,
                    cartaMembretada: null,
                    comentarios: ''
                });

            })
            .catch(error => {
                console.error(error);
                if (error.message === '413') {
                    showAlerta('error', 'Los archivos son muy pesados. Por favor, reduzca su tamaño.');
                } else {
                    showAlerta('error', 'Error al enviar el formulario');
                }
            });
    };

    return (
        <Box sx={{
            width: { xs: '100%', sm: '70%' }, margin: '0 auto', boxSizing: 'border-box',
            display: 'flex', flexDirection: 'column', gap: '40px',
            mt: 3,
        }}>
            {/* <Box sx={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderRadius: '8px',
                backdropFilter: 'blur(10px)',
                p: 3,
            }}>
                <Typography variant="h6" gutterBottom fontWeight={600}>Acreditaciones de Prensa - Festival Villa María 2026</Typography>
                <Typography variant="body1" gutterBottom sx={{ textAlign: 'justify', width: '100%' }}>
                    Si sos periodista o representante de un medio de comunicación y querés cubrir el 58º Festival Internacional de Peñas, completá el siguiente formulario.
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ textAlign: 'justify', width: '100%' }}>
                    La solicitud no garantiza la acreditación automática. El equipo de prensa evaluará cada pedido y se comunicará oportunamente.
                </Typography>
            </Box> */}

                       <Typography variant="h6" gutterBottom fontWeight={600} sx={{
                        textAlign: 'center',
                        height: '300px',
                        width: '100%',
                        mt: 5,
                        lineHeight: 1,
                    }}>
                        Ha finalizado el período de acreditación de prensa.<br/><br/>
                        Muchas gracias a todos aquellos que han enviado su solicitud.<br/><br/>
                        En los próximos días nos estaremos comunicando vía mail.
                    </Typography>

            {/* <Box component="form" onSubmit={handleSubmit} sx={{
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderRadius: '8px',
                backdropFilter: 'blur(10px)',
                p: 3,
                mb: 4
            }}>
                <Typography variant="h4" gutterBottom>Datos del Formulario</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Nombre*"
                            value={formulario.nombre}
                            onChange={handleChange('nombre')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Apellido*"
                            value={formulario.apellido}
                            onChange={handleChange('apellido')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="DNI*"
                            value={formulario.dni}
                            onChange={handleChange('dni')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Email*"
                            type="email"
                            value={formulario.email}
                            onChange={handleChange('email')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Teléfono*"
                            value={formulario.telefono}
                            onChange={handleChange('telefono')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Tipo de Medio*"
                            value={formulario.tipoMedio}
                            onChange={handleChange('tipoMedio')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Nombre del Medio*"
                            value={formulario.nombreMedio}
                            onChange={handleChange('nombreMedio')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Localidad*"
                            value={formulario.localidad}
                            onChange={handleChange('localidad')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            label="Instagram"
                            value={formulario.instagram}
                            onChange={handleChange('instagram')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            label="Facebook"
                            value={formulario.facebook}
                            onChange={handleChange('facebook')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            label="X (ex Twitter)"
                            value={formulario.twitter}
                            onChange={handleChange('twitter')}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="body2" gutterBottom>Foto personal (para credencial)*</Typography>
                        <TextField
                            type='file'
                            fullWidth
                            onChange={(event) => handleFileChange('foto')(event)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="body2" gutterBottom>Carta membretada del medio*</Typography>
                        <TextField
                            type='file'
                            fullWidth
                            onChange={(event) => handleFileChange('cartaMembretada')(event)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Comentarios"
                            value={formulario.comentarios}
                            onChange={handleChange('comentarios')}
                            multiline
                            rows={4}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="contained"
                            type="submit"
                            sx={{
                                backgroundColor: '#D4A646',
                                color: '#FFFFFF',
                                '&:hover': {
                                    backgroundColor: '#D4A646',
                                },
                                mt: 2,
                                py: 1.5
                            }}
                            fullWidth>Enviar Solicitud</Button>
                    </Grid>
                </Grid>
            </Box> */}
        </Box>
    );
}
